// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell_cell__3BxHb"};